import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {FiChevronRight, FiEye, FiHome} from "react-icons/fi";
import {Link} from "react-router-dom";
import {addCampaign, getAllCampaigns, getAllPublishers} from "../services/campaignServices";
import cx from "classnames";
import * as XLSX from 'xlsx';
import FullModal from "./FullModal";
import moment from "moment";
import Modal from "./Modal";
import {useForm} from "react-hook-form";
import {CustomDropdownObject} from "../ressources/CustomComponents";

function ServicesModal({initData}){

  const {t} = useTranslation();

  return(
    <div>
      <table className="min-w-full border-collapse" id='my-applications-table'>
        <thead className="bg-gray-100 customShadow">
        <tr>
          <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
            {t("SERVICES.TABLE.SERVICE_NAME")}
          </th>
          <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
            {t("SERVICES.TABLE.OPERATOR_NAME")}
          </th>
          <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
            {t("SERVICES.TABLE.START_DATE")}
          </th>
          <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
            {t("SERVICES.TABLE.END_DATE")}
          </th>
          <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
            {t("SERVICES.TABLE.STATUS")}
          </th>
        </tr>
        </thead>
        <tbody className="text-gray-800 text-sm">
        {
          initData.map((it) =>
            <tr key={it.campaignServiceId} className={cx('border')}>
              <td className="text-left py-3 px-2">{it.serviceName}</td>
              <td className="text-left py-3 px-2">{it.operatorName}</td>
              <td className="text-left py-3 px-2">{moment(it.startDate).format('DD/MM/yyyy')}</td>
              <td className="text-left py-3 px-2">{it.endDate && moment(it.endDate).format('DD/MM/yyyy')}</td>
              <td className="text-left py-3 px-2">{it.isActive === 1 ? "Active" : "Not Active"}</td>
            </tr>
          )
        }
        </tbody>
      </table>
    </div>
  )
}

function AddCampainModal({close}){

  const {t} = useTranslation();
  const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();

  const [isActive, setIsActive] = useState(true);
  const [isPublisherSelectOpen, setIsPublisherSelectOpen] = useState(false);
  const [publisherList, setPublishersList] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState({});

  const handleSelectPublisher = (val)=>{
    setSelectedPublisher(val);
    setIsPublisherSelectOpen(false);
  }

  const onSubmit = async (data)=>{

    const submitData = {
      description: data.description,
      publisherId: selectedPublisher.publisherId,
      isActive: isActive? 1 : 0,
      allocatedCost: data.cost,
      dailyConversion: data.dailyConversion,
      monthlyConversion: data.monthlyConversion,
    };

    try {
      const res = await addCampaign(submitData);

      if(res){
        close();
      }

    } catch (e){
      console.error(e);
    }
  }

  const fetchPublishers = async () => {
    await getAllPublishers()
      .then((res) => {
        setPublishersList(res.results)
      })
      .catch((err) => {
        console.log(err)
      });
  }

  useEffect(() => {
    fetchPublishers();
  }, []);

  return(
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-4">
          <div className='px-2.5 mb-0.5 flex items-center justify-between'>
            <label className='text-xs text-gray-500 font-semibold'>
              {t("CAMPAIGNS.TABLE.DESCRIPTION")} *
            </label>
          </div>
          <input
            className='border rounded-lg px-2 py-1.5 text-sm w-full'
            placeholder={t("CAMPAIGNS.TABLE.DESCRIPTION")}
            {...register("description", {required: true})}
          />
        </div>
        <div className="mb-4" >
          <CustomDropdownObject
            label={t("CAMPAIGNS.TABLE.PUBLISHER_NAME")}
            isOpen={isPublisherSelectOpen}
            setIsOpen={setIsPublisherSelectOpen}
            itemList={publisherList}
            selectedItem={selectedPublisher}
            itemKey="publisherName"
            idKey="publisherId"
            selectItem={handleSelectPublisher}
          />
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <div className='px-2.5 mb-0.5 flex items-center justify-between'>
              <label className='text-xs text-gray-500 font-semibold'>
                {t("CAMPAIGNS.TABLE.ALLOCATED_COST")} *
              </label>
            </div>
            <input
              type="number"
              className='border rounded-lg px-2 py-1.5 text-sm w-full'
              placeholder={t("CAMPAIGNS.TABLE.ALLOCATED_COST")}
              {...register("cost", {required: true})}
            />
          </div>
          <div>
            <div className='px-2.5 mb-0.5 flex items-center justify-between'>
              <label className='text-xs text-gray-500 font-semibold'>
                {t("CAMPAIGNS.TABLE.DAILY_TARGET_CONVERSION")} *
              </label>
            </div>
            <input
              type="number"
              className='border rounded-lg px-2 py-1.5 text-sm w-full'
              placeholder={t("CAMPAIGNS.TABLE.DAILY_TARGET_CONVERSION")}
              {...register("dailyConversion", {required: true})}
            />
          </div>
          <div>
            <div className='px-2.5 mb-0.5 flex items-center justify-between'>
              <label className='text-xs text-gray-500 font-semibold'>
                {t("CAMPAIGNS.TABLE.MONTHLY_TARGET_CONVERSION")} *
              </label>
            </div>
            <input
              type="number"
              className='border rounded-lg px-2 py-1.5 text-sm w-full'
              placeholder={t("CAMPAIGNS.TABLE.MONTHLY_TARGET_CONVERSION")}
              {...register("monthlyConversion", {required: true})}
            />
          </div>
        </div>
        <div className="flex items-center justify-between mt-7">
          <div className="h-8 flex items-center">
            <label className="inline-flex items-center cursor-pointer">
              <input type="checkbox" value="" className="sr-only peer" checked={isActive}
                     onChange={(e) => setIsActive(e.target.checked)}/>
              <div
                className="relative z-0 w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
              <span className="ms-3 text-sm font-medium text-gray-900">{t("CAMPAIGNS.TABLE.IS_ACTIVE")}</span>
            </label>
          </div>
          <input
            type="submit"
            value={t("GLOBAL.SAVE")}
            className='border border-azure font-semibold cursor-pointer rounded-lg px-4 py-1.5 text-sm text-azure hover:text-white hover:bg-azure'
          />
        </div>
      </form>
    </div>
  )
}

function Campaigns() {

  const {t} = useTranslation();

  const [campaigns, setCampaigns] = useState([]);
  const [isServicesModalOpen, setIsServicesModalOpen] = useState(false);
  const [servicesModalData, setServicesModalData] = useState([]);
  const [isAddCampaignModalOpen, setIsAddCampaignModalOpen] = useState(false);

  const openServicesModal = (services) => {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    setServicesModalData(services);
    setIsServicesModalOpen(true);
  }
  const closeServicesModal = () => {
    document.getElementsByTagName('body')[0].style.overflowY = "scroll";
    setIsServicesModalOpen(false);
    setServicesModalData([]);
  }

  const openAddCampaignModal = () => {
    document.getElementsByTagName('body')[0].style.overflowY = "hidden";
    setIsAddCampaignModalOpen(true)
  }

  const closeAddCampaignModal = () => {
    document.getElementsByTagName('body')[0].style.overflowY="scroll";
    setIsAddCampaignModalOpen(false);
    fetchAllCampaigns();
  }

  const fetchAllCampaigns = async () => {
    await getAllCampaigns()
      .then((res) => setCampaigns(res.results))
      .catch((err) => {
        console.log(err)
      });
  }

  useEffect(() => {
    fetchAllCampaigns();
  }, []);

  function exportToExcel(tableData, fileName) {
    const ws = XLSX.utils.json_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  return (
    <div>
      <div className="text-gray-500 flex items-center gap-2 mt-2 mb-6">
        <span className="text-xs font-semibold flex items-center">
          <FiHome size={12}/> <FiChevronRight size={12}/>
        </span>
        <h4 className="text-xs font-semibold text-gray-500">{t("CAMPAIGNS.TITLE")}</h4>
      </div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold">{t("CAMPAIGNS.TITLE")}</h1>
        <button onClick={()=> openAddCampaignModal() } className="cursor-pointer bg-azure px-4 py-2 text-sm font-semibold rounded-lg text-white hover:opacity-60 hover:shadow">
          {t("CAMPAIGNS.ADD_BTN")}
        </button>
      </div>
      <div className='bg-white p-0 rounded-lg mt-4 shadow overflow-x-auto'>
        <table className="min-w-full border-collapse" id='my-applications-table'>
          <thead className="bg-gray-100 customShadow">
          <tr>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("CAMPAIGNS.TABLE.CAMPAIGN_ID")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("CAMPAIGNS.TABLE.DESCRIPTION")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("CAMPAIGNS.TABLE.PUBLISHER_NAME")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
              {t("CAMPAIGNS.TABLE.IS_ACTIVE")}
            </th>
            <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
                {t("CAMPAIGNS.TABLE.ALLOCATED_COST")}
              </th>
              <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
                {t("CAMPAIGNS.TABLE.DAILY_TARGET_CONVERSION")}
              </th>
              <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
                {t("CAMPAIGNS.TABLE.MONTHLY_TARGET_CONVERSION")}
              </th>
              <th className="text-left py-3 px-2 uppercase font-semibold text-xs">
                {t("CAMPAIGNS.TABLE.CAMPAIGN_SERVICES")}
              </th>
            </tr>
          </thead>
          <tbody className="text-gray-800 text-sm">
          {
            campaigns.map((it) =>
              <tr key={it.campaignId} className={cx('border')}>
                <td className="text-left py-3 px-2">{it.campaignId}</td>
                <td className="text-left py-3 px-2">{it.description}</td>
                <td className="text-left py-3 px-2">{it.publisherName}</td>
                <td className="text-left py-3 px-2">{it.isActive === 1 ? "True" : "False"}</td>
                <td className="text-left py-3 px-2">{it.allocatedCost}</td>
                <td className="text-left py-3 px-2">{it.dailyTargetConversion}</td>
                <td className="text-left py-3 px-2">{it.monthlyTargetConversion}</td>
                <td className="flex items-center justify-center py-3 px-2" >
                  <button onClick={()=> openServicesModal(it.campaignServices) } className="hover:text-azure" >
                    <FiEye size={18} />
                  </button>
                </td>
              </tr>
            )
          }
          </tbody>
        </table>
      </div>

      <FullModal isOpen={isServicesModalOpen} close={closeServicesModal} title={t("CAMPAIGNS.TABLE.CAMPAIGN_SERVICES")} >
        <ServicesModal initData={servicesModalData} />
      </FullModal>

      <Modal
        isOpen={isAddCampaignModalOpen}
        close={closeAddCampaignModal}
        title={t("CAMPAIGNS.ADD_BTN")}
        isWithoutOverflow
      >
        <AddCampainModal close={closeAddCampaignModal} />
      </Modal>
    </div>
  );
}

export default Campaigns;
